import { create } from "zustand";

export const useManageOfferingsStore = create((set) => ({
  offeringFeedbackSettingsModalOpen: false,
  setOfferingFeedbackSettingsModalOpen: (value) =>
    set({ offeringFeedbackSettingsModalOpen: value }),

  // Current Offering & Recorded Content Details
  currentOffering: null,
  setCurrentOffering: (value) => set({ currentOffering: value }),

  currentRecordedContentDetails: null,
  setCurrentRecordedContentDetails: (value) =>
    set({ currentRecordedContentDetails: value }),

  // Booking Questions (Start)
  listingFormQuestionsList: [],
  setListingFormQuestionsList: (value) =>
    set({ listingFormQuestionsList: value }),
  listingFormQuestionsListLoading: false,
  setListingFormQuestionsListLoading: (value) =>
    set({ listingFormQuestionsListLoading: value }),
  // Booking Questions (End)
}));
